import { Outlet } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useFlags } from 'providers/FlagsProvider';
import { rumService } from 'services/rum';

function Signup() {
  const { flags } = useFlags();

  useEffect(() => {
    rumService.addRumGlobalContext('flags', JSON.stringify(flags));
  }, [flags]);

  return <Outlet />;
}

export default Signup;
